import { __assign } from "tslib";
import * as React from 'react';
import { Modal, ModalMobileLayout, Heading, Text, Box, Button, } from 'wix-style-react';
import { biLogger } from '../../../bi';
import { composer } from '../../../component-decorators/composer';
import { config } from '../../../config';
function InstallationNotSupportedMobileBase(_a) {
    var t = _a.t, appName = _a.appName, marketplaceStore = _a.marketplaceStore, msid = _a.msid, appId = _a.appId;
    function handleClose() {
        return marketplaceStore.closeAllModals();
    }
    React.useEffect(function () {
        biLogger.appMarketMobileAlertForInstallMoveToDesktop({
            app_id: appId,
            msid: msid,
        });
    });
    function getContent() {
        return (React.createElement(Box, { direction: "vertical", align: "center", textAlign: "center", marginTop: "103px", marginLeft: "24px", marginRight: "24px" },
            React.createElement("img", { src: config.marketplaceStaticsUrl + "assets/images/mobile-install-block-mobile.svg" }),
            React.createElement(Box, { marginTop: "46px" }),
            React.createElement(Heading, { appearance: "H2" },
                t('modals-installationNotSupportedMobile-title'),
                ' '),
            React.createElement(Box, { marginTop: "12px", marginBottom: "36px" },
                React.createElement(Text, { skin: "standard", secondary: true, weight: "thin" },
                    t('modals-installationNotSupportedMobile-content', { appName: appName }),
                    ' ')),
            React.createElement(Button, { onClick: handleClose },
                ' ',
                t('modals-installationNotSupportedMobile-cta'),
                ' ')));
    }
    return (React.createElement(Modal, { isOpen: true, zIndex: 100000 },
        React.createElement(ModalMobileLayout, { onCloseButtonClick: handleClose, content: getContent(), fullscreen: true })));
}
var InstallationNotSupportedMobile = composer()
    .withTranslation()
    .withMarketplaceStore()
    .compose(function (props) { return (React.createElement(InstallationNotSupportedMobileBase, __assign({}, props))); });
export { InstallationNotSupportedMobile, InstallationNotSupportedMobileBase, };
//# sourceMappingURL=installation-not-supported-mobile.js.map